import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useNavItems } from "./useNavItems";

const NavbarDesktopMenu: React.FC = () => {
    const items = useNavItems();
    const location = useLocation();
    const [openItem, setOpenItem] = useState<string | null>(null);
    const menuRef = useRef<HTMLUListElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                setOpenItem(null);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        setOpenItem(null);
    }, [location.pathname]);

    return (
        <ul className="navbar-desktop-menu" ref={menuRef}>
            {items.map((item) =>
                item.children ? (
                    <li
                        key={item.label}
                        className={`navbar-desktop-item has-children ${openItem === item.label ? "open" : ""}`}
                    >
                        <button
                            type="button"
                            className="navbar-desktop-link"
                            onClick={() => setOpenItem(prev => (prev === item.label ? null : item.label))}
                        >
                            {item.label}
                            <span className="navbar-desktop-caret" />
                        </button>
                        {openItem === item.label && (
                            <ul className="navbar-desktop-submenu">
                                {item.children.map((child) => (
                                    <li key={child.label}>
                                        <Link to={child.path} onClick={() => setOpenItem(null)}>
                                            {child.label}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </li>
                ) : (
                    <li key={item.label} className="navbar-desktop-item">
                        <Link className="navbar-desktop-link" to={item.path!}>
                            {item.label}
                        </Link>
                    </li>
                )
            )}
        </ul>
    );
};

export default NavbarDesktopMenu;
